import { createBrowserRouter } from "react-router-dom";

import { ApiProvider } from "../providers/api/apiProvider";
import { ProductAccessUnavailable } from "../pages/ProductAccess";

export const productAccessRouter = createBrowserRouter([
  {
    path: "/",
    Component: ApiProvider,
    children: [
      {
        path: "*",
        Component: ProductAccessUnavailable,
      },
    ],
  },
]);
